// extracted by mini-css-extract-plugin
module.exports = {"validationTips":"_ca81b9d","suggestions":"_d45c57e","suggestion":"_cfcb9ae"};